<template>
  <div>
    <span class="link" @click="handleLinkClick">
      {{ quoteId }}
    </span>
    <i v-if="archived" class="fa-regular fa-archive ml-1 text-blue" />
  </div>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

export default {
  props: {
    quoteId: {
      type: Number,
      default: null
    },
    archived: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleLinkClick() {
      EventBus.$emit("datatable-show-quote", { quoteId: this.quoteId });
    }
  }
};
</script>
